<template>
  <DialogTemplateToolkit
    class-name="create-cart-dialog width-100"
    :data-qa="dataQa"
    :dialog.sync="dialog"
    :disabled="loading"
    :loading="loading"
    :title="dialog_name || $t('Catalog.AddItem')"
    @apply="createCart"
    @close="close">
    <template #activator-btn>
      <div
        v-if="btn_text"
        class="flex">
        <sInput
          autofocus
          class-name="search-field"
          clearable
          :data-qa="`${dataQa}-search`"
          :placeholder="$t('Tenders.LotsSearch')"
          prefix-icon="search"
          :value.sync="search"
          @update:value="searching"/>
        <template
          v-if="!app_mode || $can('add', 'appResources')">
          <span class="card-title-text mx-6  my-auto">{{ $t('Common.Or') }}</span>
          <sButton
            class="h11-links"
            :data-qa="`btn-${dataQa}-open`"
            type="border"
            @click="open">
            <sIcon
              class="s-svg-icon-rotate-45 mr-2 my-auto"
              size="10"
              type="crossed"/>
            {{ btn_text }}
          </sButton>
        </template>
      </div>
      <div
        v-else
        class="list-item options-item "
        @click="open">
        <sIcon
          class="list-item-icon my-auto"
          type="edit"/>
        <div
          class="list-item-title  h11-links">
          {{ $t('Common.Edit') }}
        </div>
      </div>
    </template>
    <template #card-text>
      <div class="pr-10 pl-0 flex-direction-column align-start">
        <sForm
          ref="newItemForm"
          :disabled="loading"
          label-position="top"
          label-width="100px"
          :model="formData"
          :rules="newItemFormRules">
          <sFormItem
            item-style="width: 440px"
            :label="$t('Planning.Name')"
            prop="name">
            <sInput
              clearable
              data-qa="resource-name"
              :max-length="4000"
              max-rows="20"
              :placeholder="$t('Common.EnterName')"
              rows="1"
              type="textarea"
              :value.sync="formData.name"/>
          </sFormItem>
          <sFormItem
            v-if="app_mode"
            ref="formItemBiddingTypeId"
            item-style="width: 440px"
            :label="$t('Tenders.Category')"
            prop="category_code">
            <CategoryDropdownTree
              ref="category"
              class="v-input category"
              data-qa="category"
              input-type="textarea"
              :label="$t('Tenders.Category')"
              :model.sync="formData.category_code"/>
          </sFormItem>
          <sFormItem
            ref="formItemBiddingTypeId"
            item-style="width: 440px"
            :label="$t('Tenders.UnitOfMeasurement')"
            prop="measur">
            <sSelect
              clearable
              data-qa="measurement"
              filterable
              :loading="measur_loading"
              :placeholder="$t('Tenders.UnitOfMeasurement')"
              style="width: 100%"
              :value.sync="formData.measur">
              <sOption
                v-for="unitItem in measurement_units"
                :key="`tender-currency-${unitItem[app_mode ? 'id' : 'publicId']}`"
                :data-qa="`tender-currency-item-${unitItem[app_mode ? 'id' : 'publicId']}`"
                :label="unitItem.fullName"
                :value="unitItem[app_mode ? 'id' : 'publicId']"/>
            </sSelect>
          </sFormItem>
          <div
            v-if="topUnits && topUnits.length"
            class="top-unit">
            <div
              class="top-unit__title">
              {{ $t('Common.top-used-measurement-singles') }}
            </div>
            <div class="flex">
              <div
                v-for="topUnit in topUnits"
                :key="topUnit.unitId"
                class="chip-item"
                :class="{'active': formData.measur === topUnit.unitCode}"
                dense
                :outlined="formData.measur !== topUnit.unitCode"
                @click="formData.measur = topUnit.unitCode">
                <span
                  class="chip-item-text"> {{ topUnit.unitTitle }} </span>
              </div>
            </div>
          </div>
          <sFormItem
            ref="formItemBiddingTypeId"
            item-style="width: 440px"
            :label="$t('Tenders.Additionally')"
            prop="additional">
            <sInput
              clearable
              data-qa="additional-description"
              :max-length="4000"
              max-rows="20"
              :placeholder="$t('Tenders.Additionally')"
              show-word-limit
              type="textarea"
              :value.sync="formData.additional"/>
          </sFormItem>
        </sForm>
      </div>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import CategoryDropdownTree from 'components/common/dialogs/CategoryDropDownTree.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import { modalMixin } from 'mixins'

export default {
  name: 'createNewItemInCatalog',
  mixins: [ modalMixin ],
  data() {
    const that = this
    return {
      dialog: false,
      search: '',
      measurement_units: null,
      loading: false,
      measur_loading: false,
      formData: {
        name: '',
        category_code: '',
        measur: null,
        additional: null,
      },
      newItemFormRules: {
        name: [
          {
            type: 'string',
            trigger: 'change',
            required: true,
            validator(rule, value, callback) {
              if (!value || !value.length) {
                callback(new Error(that.$t('Validate.Required')))
                return
              }
              if (value.length > 254) {
                callback(new Error(that.$t('Validate.maxLength', {number: 254, type: that.$tc('Common.characters', 10) })))
                return
              }
              if (that.existItem?.length) {
                const currentId = that.item?.id
                if (that.existItem.find(i => i.title.trim() === value.trim()
                 && i.nomenclatureUnitId === that.formData.measur
                 && (!currentId || i.id !== currentId)
                )) {
                  callback(new Error(that.$t('Validate.NameAndMeasureExist')))
                }
              }
              callback()
            },

          }
        ],
        category_code: [{
          required: true,
          trigger: 'change',
          message: this.$t('Validate.Required')
        }],
        measur: [{
          required: true,
          trigger: 'change',
          message: this.$t('Validate.Required')
        }],
        additional: [{
          type: 'string',
          max: 4000,
          message: this.$t('Validate.maxLength', {number: 4000, type: this.$tc('Common.characters', 10) })
        }]
      }
    }
  },
  props: {
    item: Object,
    dialog_name: String,
    search_text: String,
    btn_text: String,
    create: Function,
    getMeasur: String,
    app_mode: Boolean,
    dataQa: {
      type: String,
      default: 'create-new-item-in-catalog'
    },
    topUnits: {
      type: Array
    },
    existItem: {
      type: Array
    }
  },
  created() {
    this.measur_loading = true
  },
  methods: {
    searching(val) {
      this.$emit('searching', val)
    },
    createCart() {
      this.$refs.newItemForm.validate(async (valid) => {
        if (!valid) { return }
        this.loading = true
        try {
          this.create(this.formData.name, this.formData.measur, this.formData.additional,  this.formData.category_code || '', this.resourceId)
          this.loading = false
          this.close()
        } catch (err) {
          this.$log_error(err)
          this.loading = false
        }
      })
    },
    close() {
      this.$set(this, 'search', '' )
      this.$set(this.formData, 'name', null )
      this.$set(this.formData, 'measur', null )
      this.$set(this.formData, 'additional', null )
      this.$set(this.formData, 'category_code', '' )

      this.$set(this, 'dialog', false )

      this.$emit('close')
      this.$nextTick( this.$refs.newItemForm.clearValidate )
    },
    open() {
      let self = this
      if ( !self.measurement_units ) {
        this.$store.dispatch(this.getMeasur)
          .then((res) => {
            this.measurement_units = res?.map(el => ({
              fullName: el.fullName || el.unitTitle || el.name,
              id: el.id || el.unitId,
              publicId: el.publicId || el.unitCode,
              shortName: el.shortName || el.unitShortTitle
            }))?.sort((a,b ) =>  a.fullName?.localeCompare(b.fullName))
          })
          .finally(() => {
            this.measur_loading = false
          })
      }
      setTimeout(() => {
        if (self.item) {
          self.formData.name = self.item.lotSubject || self.item.fullName || self.item.resourceName
           || self.item.title || self.item.resource?.fullName || self.item.name
          self.formData.additional = self.item.description || self.item.comment

          self.formData.measur = this.app_mode ? self.item.unit?.id : self.item.nomenclatureUnitId || self.item.measurementUnit?.publicId
          if ( !self.formData.measur ) {
            let measur = self.measurement_units.find(el => {
              return  el.publicId == self.item.measuringUnit
                || self.item.unit?.id == el.id
                || self.item.nomenclatureUnitId == el.publicId
            })
            self.formData.measur =  this.app_mode ? measur?.id : measur?.publicId
          }
          self.formData.category_code = self.item?.resource?.category?.code || self.item?.category?.code
            || self.item?.resource?.codeCpv || self.item?.codeCpv || self.item?.resource?.resourceGroup?.id
            || self.item?.resourceGroup?.id || self.item?.resource?.resourceGroup
          self.resourceId = self.item?.resource?.id || self.item?.id
        } else {
          self.formData.name = self.search
        }

        self.$emit('open', self.formData.category_code)
        self.dialog = true
      }, 200 )
    }
  },
  components: {
    CategoryDropdownTree,
    DialogTemplateToolkit
  }
}
</script>
<style lang="scss" scoped>
.chip-item {
  padding: 2px 8px;
  border-radius: 16px;
  margin-inline: 3px;
  align-items: center;
  cursor: pointer;
  display: flex;
  font-weight: 600;
  height: 26px !important;
  margin-top: 8px;
  border: 1px solid var(--black-color);
  transition: all 0.25s;
  font-size: 12px;
  &.active {
    background-color: var(--v-main__green-base);
    border-color: var(--v-main__green-base);
  }
  &:hover,
  &:focus {
    background: #e0e0e0;
    &.active {
      background-color: #c1dddb;
      border-color: #c1dddb;
    }
  }
}
.chip-item-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 250px;
}

.top-unit {
  margin-bottom: 10px;
 &__title {
    font-size: 14px;
    color: var(--text-color);
    line-height: 1.25;
  }
  &__item {
    cursor: pointer;
    transition: 0.25s;
    &:hover,
    &:focus,
    &.active {
      font-weight: bold;
    }
  }
}
.create-cart-icon-10 {
  width: 10px;
  min-width: 10px !important;
}
.search-field {
  width: 490px;
  .v-input__prepend-inner {
    margin: auto;
  }
}
.create-cart-dialog {

  .v-input {
    width: 100%;
  }
}
.create-cart-catalog {
  .tree-item {
    max-width: 480px
  }
}
</style>
